const createVariableModal = {
  bindings: {
    variables: '<',
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl: '/modules/pis-tool/variables/create-variable-modal/create-variable-modal.html',
  controller: 'CreateVariableModalController',
};

angular
    .module('pis-tool.module')
    .component('createVariableModal', createVariableModal);